export default __webpack_public_path__ + "static/media/title-fleet.4f37acd7.svg";